(function (Component, Section, Event, SharedComponent, dragulish, Row) {
  // make sure to
  // trigger pb:component:save on success
  // trigger warning dialogs on failures

  function Drag(sidebar) {
    var page = sidebar.page,
      $previewBody = jQuery(page.element),
      $previewDoc = jQuery(page.element.ownerDocument),
      drake = dragulish(
        ["[data-component-section]", "#blank-components_fieldset_content", "#shared-components_fieldset_content"],
        { moves: draggable },
      ),
      _dragData,
      _dragElement,
      _item,
      _dropZones,
      _lastOver,
      _initialRow,
      _insertAbove,
      _insertBelow,
      _scrolling,
      _dragTimeout,
      _dragWaiting;

    // given some component data find the config
    function getConfig(component) {
      var config = component.config || page.config[component.templateId || component.template];
      if (config) {
        return config;
      } else {
        throw new Error("Trying to drag a component that doesn't exist");
      }
    }

    // Based on the element being dragged determine the kind of component
    // and find the config
    function setDragData(item) {
      var templateId = item.dataset.templateId,
        newComponent = templateId ? Component.fromConfig(templateId, page.config) : null,
        shared = SharedComponent.lightweight(item.dataset.componentId) || null,
        existing = Component.find(item) || null;

      var columns, config;

      config = getConfig(shared || newComponent || existing);

      if (existing) {
        columns = existing.columns();
      } else if (newComponent || shared) {
        columns = config.columns;
      }

      var component = newComponent || existing || shared,
        section,
        position;

      if (component.section) {
        section = component.section;
        position = component.position();
      }

      var data = {
        item: item,
        shared: shared,
        newComponent: newComponent,
        existing: existing,
        columns: columns,
        config: config,
        component: component,
        initialSection: section,
        initialPosition: position,
      };

      function callback(response) {
        data.component = SharedComponent.create(response, page.config);
        return data.component;
      }

      if (data.shared) {
        data.promise = SharedComponent.fetch(shared.id).then(callback);
      } else {
        var deferred = jQuery.Deferred();
        deferred.resolve(data.component);
        data.promise = deferred.promise();
      }

      _dragData = data;

      return data;
    }

    function DropZones() {
      var rows = Section.createRows();
      var rowsById = {};
      rows.forEach(function (row) {
        rowsById[String(row.id)] = row;
        row.createElement();
      });

      return {
        rows: rows,
        rowsById: rowsById,
        cleanup: function () {
          var $page = jQuery(page.element);
          $page.find(".empty-drop-zone").remove();
          $page.find(".drop-zone").remove();
        },
      };
    }

    // remove drop zone divs
    function removeDropZones() {
      if (_dropZones) {
        _dropZones.cleanup();
        _dropZones = null;
      }
    }

    // reset everything to pre-drag
    function cleanup() {
      _dragWaiting = false;
      clearTimeout(_dragTimeout);
      $previewBody.removeClass("dragging");
      jQuery(document.body).removeClass("dragging");
      jQuery(".components.over").removeClass("over");
      cleanupClasses();
      removeDropZones();
      jQuery(_dragElement).remove();
      jQuery(_item).removeClass("in-transit");
    }

    // add special drop zone divs to help show empty sections when dragging
    // and indicate when adding a component to a row
    function addDropZones() {
      cleanup();
      _dropZones = DropZones();
    }

    function draggable(item, source, handle, sibling) {
      return item.classList.contains("component") || item.classList.contains("draggable");
    }

    function setDragElement(config) {
      const image = document.createElement("sp-icon");
      image.setAttribute("name", `${config.icon_name}-color`);
      image.setAttribute("size", "m");

      const container = document.createElement("div");
      container.appendChild(image);

      _dragElement = container.cloneNode(true);
      _dragElement.classList.add("drag-image");

      jQuery(document.body).prepend(_dragElement);
      return _dragElement;
    }

    function clientY(element) {
      var $element = jQuery(element),
        doc = page.element.ownerDocument,
        win = doc.defaultView || doc.parentWindow,
        rect = win.frameElement.getBoundingClientRect();
      return $element.offset().top - jQuery(doc).scrollTop() + rect.top;
    }

    function insertingAbove($dropZone, y) {
      var elementTop = clientY($dropZone[0]),
        height = $dropZone.outerHeight(),
        cushion = height * 0.1;

      if (y - elementTop < cushion) {
        _insertAbove = true;
        return true;
      } else {
        return false;
      }
    }

    function insertingBelow($dropZone, y) {
      var elementTop = clientY($dropZone[0]),
        elementBottom = elementTop + $dropZone.outerHeight(),
        height = $dropZone.outerHeight(),
        cushion = height * 0.1;

      if (elementBottom - y < cushion) {
        _insertBelow = true;
        return true;
      } else {
        return false;
      }
    }

    function inserting($dropZone, y) {
      _insertAbove = false;
      _insertBelow = false;

      if ($dropZone.length) {
        return insertingAbove($dropZone, y) || insertingBelow($dropZone, y);
      } else {
        return false;
      }
    }

    function scrollingDown(y) {
      return y > window.document.body.clientHeight - 40;
    }

    function scrollingUp(y) {
      var iframeTop = jQuery("#page-preview").offset().top;
      return y < iframeTop + 40;
    }

    function scrolling(y) {
      return scrollingUp(y) || scrollingDown(y);
    }

    function isDropZone(item) {
      var $item = jQuery(item);
      return (
        $item.parents(".empty-drop-zone").length ||
        $item.hasClass("empty-drop-zone") ||
        $item.parents(".drop-zone").length ||
        $item.hasClass("drop-zone")
      );
    }

    function getDropZone(item) {
      var $item = jQuery(item);
      return $item.closest(".empty-drop-zone")[0] || $item.closest(".drop-zone")[0] || null;
    }

    function isRow(item) {
      var rowId = Number(item.dataset.rowId);
      return rowId || rowId === 0;
    }

    function getRow(item) {
      if (!item) {
        return null;
      }
      // data-row-id is Row#id, not Row.rows index (e.g. after reinit). Built once in DropZones.
      return _dropZones.rowsById[String(item.dataset.rowId)] || null;
    }

    function canAdd(item) {
      if (isDropZone(item)) {
        if (isRow(item)) {
          var row = getRow(item);
          return row.canAdd(_dragData);
        } else {
          //empty drop zone
          return true;
        }
      } else {
        return false;
      }
    }

    function cleanupClasses(element) {
      $previewBody.removeClass("can-not-add");
      if (element) {
        var $element = jQuery(element);
        $element.removeClass("over");
        $element.removeClass("can-add");
        $element.removeClass("row-full");
        $element.removeClass("inserting-above");
        $element.removeClass("inserting-below");
        $element.removeClass("reordering");
        $element.removeClass("reorder-here");
      }
    }

    function addClasses(element) {
      var $element = jQuery(element),
        row = getRow(element);

      // if this isn't the initial row
      if (row !== _initialRow) {
        // if we can add this component to the row
        if (canAdd(element)) {
          $element.addClass("can-add");
          // don't change innerhtml of empty drop zones
          if (element.classList.contains("drop-zone")) {
            $element.html("Add to row");
          }
        } else {
          // row is too full
          $element.addClass("row-full");
          $element.html("Can't add to row");
          $previewBody.addClass("can-not-add");
        }
      } else {
        // we are over the initial row and are therefore reordering
        $element.addClass("reordering");
      }
    }

    function scroll(y) {
      function move() {
        if (_scrolling) {
          if (scrollingUp(y)) {
            $previewDoc.scrollTop($previewDoc.scrollTop() - 1);
          } else if (scrollingDown(y)) {
            // for some reason this has to be at least 2. If set to 1 nothing happens.
            $previewDoc.scrollTop($previewDoc.scrollTop() + 2);
          }
          window.requestAnimationFrame(move);
        }
      }

      if (!_scrolling) {
        _scrolling = true;
        _lastOver = null;
        move();
      }
    }

    function insertLine($dropZone, y) {
      const sectionName = $dropZone.parent().data("component-section-title");
      const addInsertText = !$dropZone.hasClass("empty-drop-zone");

      if (insertingAbove($dropZone, y)) {
        $dropZone.removeClass("inserting-below");
        $dropZone.addClass("inserting-above");
        if (addInsertText) {
          $dropZone.html("Add above '" + sectionName + "'");
        }
      } else if (insertingBelow($dropZone, y)) {
        $dropZone.removeClass("inserting-above");
        $dropZone.addClass("inserting-below");
        if (addInsertText) {
          $dropZone.html("Add below '" + sectionName + "'");
        }
      }
    }

    drake.on("drag", function (item, from) {
      localStorage.setItem("dragging", "true");
      clearTimeout(_dragTimeout);
      _dragWaiting = true;
      _dragTimeout = setTimeout(function () {
        setDragData(item);
        _dragWaiting = false;
        addDropZones();
        _initialRow = _dragData.component.row;
        _item = item;
        $previewBody.addClass("dragging");
        jQuery(document.body).addClass("dragging");
        jQuery(_item).addClass("in-transit");
        setDragElement(_dragData.config);
        if (_initialRow && _initialRow.components.length > 1) {
          // initial row can be reordered
          _initialRow.createComponentElements();
        }
      }, 300);
    });

    drake.on("dragend", function (item, from) {
      localStorage.removeItem("dragging");
      cleanup();
      _dragData = null;
      _initialRow = null;
      _insertAbove = null;
      _insertBelow = null;
    });

    drake.on("drop", function (item, to, from, sibling) {
      if (!_dragWaiting) {
        function remove(row, component) {
          if (row) {
            row.remove(component);
          }
        }

        var dropZone = getDropZone(_lastOver),
          newRow = getRow(dropZone),
          component = _dragData.component,
          sameRow = _initialRow === newRow,
          section;

        if (newRow) {
          section = newRow.section;

          if (sameRow && _initialRow.components.length === 1) {
            // do nothing, this essentially ends up with the component in
            // the exact same spot, might as well just do nothing.
            completeDrop(_dragData);
          } else if (_insertBelow && section.canInsertAfter(newRow)) {
            var rowBelow = section.newRowAfter(newRow),
              position;

            remove(_initialRow, component);
            if (newRow.components.length > 0) {
              position = newRow.components[newRow.components.length - 1].position() + 1;
            } else {
              position = 0;
            }
            rowBelow.append(component, position);
            completeDrop(_dragData);
          } else if (_insertAbove && section.canInsertBefore(newRow)) {
            var rowAbove = section.newRowBefore(newRow),
              position;

            remove(_initialRow, component);
            position = newRow.components[0].position();
            rowAbove.append(component, position);
            completeDrop(_dragData);
          } else if (sameRow && newRow.components.length > 1) {
            // reorder only if it was over a placeholder
            if (jQuery(_lastOver).hasClass("reorder-placeholder")) {
              newRow.move(_dragData.component, Number(_lastOver.dataset.index));
            }
            completeDrop(_dragData);
          } else if (canAdd(dropZone)) {
            // might have to wait for shared component

            // _dragData and _initialRow are cleared synchronously so we need to save them so we can use them in the callback
            var deferredDragData = _dragData;
            var deferredInitialRow = _initialRow;
            _dragData.promise.then(function () {
              removeDropZones();
              remove(deferredInitialRow, component);
              newRow.append(deferredDragData.component);
              completeDrop(deferredDragData);
            });
          }

          // Steps to complete the drop. Wrapped in a function so they can be called asynchronously from a Promise
          function completeDrop(dragData) {
            var positionChanged = dragData.initialPosition !== component.position(),
              sectionChanged = dragData.initialSection !== component.section;

            if (component.inherited && (positionChanged || sectionChanged)) {
              component.data("position", component.position());
            }
            // Select the component after placement
            sidebar.editComponent(component.element);
          }
        }
      }
    });

    drake.on("over", function (item, container, from) {
      if (!_dragWaiting) {
        jQuery(container).addClass("over");
      }
    });

    drake.on("out", function (item, container, from) {
      if (!_dragWaiting) {
        jQuery(container).removeClass("over");
      }
    });

    drake.on("move", function (item, lastDropTarget, source, elementBehindCursor, x, y) {
      if (!_dragWaiting) {
        const dragImageHalfWidth = _dragElement.offsetWidth / 2;
        const dragImageHalfHeight = _dragElement.offsetHeight / 2;
        _dragElement.style.left = `${x - dragImageHalfWidth}px`;
        _dragElement.style.top = `${y - dragImageHalfHeight}px`;

        _scrolling = false;

        cleanupClasses(getDropZone(_lastOver));
        cleanupClasses(_lastOver);

        if (elementBehindCursor !== _lastOver) {
          _lastOver = elementBehindCursor;
        }

        var dropZone = getDropZone(_lastOver),
          $dropZone = jQuery(dropZone),
          newRow = getRow(dropZone);

        $dropZone.addClass("over");

        if (scrolling(y)) {
          $dropZone.removeClass("over");
          scroll(y);
        } else if (inserting($dropZone, y)) {
          insertLine($dropZone, y);
        } else if (newRow && newRow === _initialRow && newRow.components.length > 1) {
          //reordering
          var $last = jQuery(_lastOver);
          $last.addClass("reorder-here");
        } else if (newRow && newRow === _initialRow && newRow.components.length === 1) {
          // initial row but only one component so can't reorder
          // so hide drop zone
          $dropZone.removeClass("over");
        } else {
          // regular dropping
          addClasses(dropZone);
        }
      }
    });

    return drake;
  }

  // export
  Sparkle.PageBuilder.Drag = Drag;
})(
  Sparkle.PageBuilder.Component,
  Sparkle.PageBuilder.Section,
  Sparkle.PageBuilder.Helpers.Event,
  Sparkle.PageBuilder.SharedComponent,
  window.dragulish,
  Sparkle.PageBuilder.Row,
);
